// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22uq6","colBig":"styles_colBig__3wUeg","colSmall":"styles_colSmall__2L-GI"};